export default class BigTicketBonanzaApp {
    constructor(api) {
        this.api = api;
        this.BigTicketBonanzaAppClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.bigTicketBonanzaAppInstance && this.api.settings.bigTicketBonanzaAppInstance !== instance.instance) {
            return;
        }
        if (!this.BigTicketBonanzaAppClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.jsApp) {
                await this.api.util.loadJS(instance.data.cdn.jsApp);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileGame &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.bigTicketBonanzaApp &&
                this.api.settings.widgetsUrl.bigTicketBonanzaApp.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.bigTicketBonanzaApp.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.cssApp) {
                await this.api.util.loadCSS(instance.data.cdn.cssApp);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileGame &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.bigTicketBonanzaApp &&
                this.api.settings.widgetsUrl.bigTicketBonanzaApp.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.bigTicketBonanzaApp.css]);
            }
        }
        if (window.store) {
            window.store.dispatch('addInstanceToContainer', `${instance.instance}_app`)
            this.createInstance(instance)
        }
    }

    createInstance(instance) {
        if (!document.getElementById(`ox-drawer-instance-container-${instance.instance}_app-inner`)) {
            setTimeout(()=> {
                this.createInstance(instance)
            },100)
        } else {
            this.BigTicketBonanzaAppClass = new window.Widget_bigTicketBonanzaApp.default(this.api.settings, `#ox-drawer-instance-container-${instance.instance}_app-inner`, `${instance.instance}_app`, this.api);
        }
    }
}